import script from "./RegistrationCulture.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationCulture.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationCulture.vue?vue&type=style&index=0&id=61384cae&lang=scss"

const __exports__ = script;

export default __exports__